export const LUCKY_DIP_CONSTANTS = {
    LUCKY_DIP: 'luckydip',
    API_LUCKY_DIP: 'lucky-dip',
    LUCKY_DIP_MAPPING: 'lucky-dip-mapping',
    LUCKY_DIP_TEASER_PATH: 'content/teasers?path=luckydip',
    ANIMATION_MODAL_OPEN: 'animation-modal-open',
    SPLASH_MODAL_CONTAINER: '.splash-modal-container',
    HIDE_CONTAINER: 'hideContainer',
    QUICKBET_HEADER: '.quickbet-header',
    BACKGROUND_CSS: 'background: #000000bf !important',
    HIDE_MODAL: 'hideModal',
    MODAL_BODY: '.modal-body',
    SPLASH_MODAL_CSS: '.splash-modal .modal',
    LUCKY_DIP_STORAGE_KEY: 'LuckyDip',
    QUICK_BET_SELECTION: 'quickbetSelection',
    PLAYER_CARD_DESCRIPTION_POTENTIAL: 'playerCardDescriptionPotential',
    PLAYER_NAME: 'playerName',
    OUTCOME_VALUE: 'outcomeValue',
    RETURN_DESCRIPTION: 'returnsDescription',
    AMOUNT: 'amount',
    LDIP: 'LDIP',
    MKTFLAG_LD: 'MKTFLAG_LD',
    EMPTY_STRING: '',
    TNMT: 'TNMT',
    LUCKY_DIP_KEYPAD: 'Lucky dip keypad',
    PLACE_BET_FN: 'placeBetFn',
    QB_BET_RECEIPT_TITLE: `quickbet.betReceiptTitle`,
    RECEIPT: 'receipt',
    LDIP_CHILD: 'ldipChild',
    DIALOG: 'dialog',
    DESK_LDIP_TAG: 'desk_ldip',
    LD_BET_PLACED: 'LD_BET_PLACED',
    CLOSE_PANEL_FN: 'closePanelFn',
    YOUR_BETS: 'Your Bets: (1)',
    SITE_CHANNELS: 'M',
    EVENT_SORT_CODE: 'TNMT,MTCH',
    EVENT_STATUS_CODE: 'A',
    MARKET_STATUS_CODE: 'A',
    LUCKYDIP_DIRECTIVE_NAME: 'luckydiphub',
    IS_CMS_CONFIG_LD: 'IS_CMS_CONFIG_LD',
    QUICK_DEPOSIT_STATUS: 'QUICK_DEPOSIT_STATUS',
    LD_QUICK_BET: '.luckydip-quick-bet',
    LD_CONTENT: '.luckydip-content',
    LD_QB_PANEL: '.lucky-dip-qb-panel',
    CLOSE_BETSLIP_DIALOG: 'CLOSE_BETSLIP_DIALOG',
};
